import { FC, useState } from 'react';
import { useTranslation } from 'src/components/authentication/i18n';
import { FormTextField, FormTextFieldProps } from 'src/components/FormInputs/FormTextField';
import { Visibility } from 'material-hu/icons';
import { VisibilityOff } from 'material-hu/icons';
import {
  InputAdornment,
  IconButton,
} from 'material-hu';

export type PasswordInputProps = FormTextFieldProps;

const PasswordInput: FC<PasswordInputProps> = (textFieldProps) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((prevState) => !prevState);

  return (
    <FormTextField
      {...textFieldProps}
      type={showPassword ? 'text' : 'password'}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={t('SHOW_HIDE_BUTTON')}
              onClick={handleClickShowPassword}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PasswordInput;
